import React from'react';
import './Header.css';
function Header()
{
    return(
        <header>
            <nav className="navbar">
                <h1 className="logo">Uma Rajagopal</h1>
                <ul className="nav_link">
                    <li><a href="#about">👩‍💻 About</a></li>
                    <li><a href="#skill">💡 Skills</a></li>
                    <li><a href="#resume">📄 Resume</a></li>
                    <li><a href="#project">📁 Projects</a></li>
                    <li><a href="#contact">📬 Contact</a></li>
                </ul>
            </nav>
        </header>
    );
}export default Header

